import React, { Component } from 'react';
import { BreadCrumb } from './containers/Layout';
import SingleShop from './shops/SingleShop.jsx';
import SingleReaExtern from './reapproExtern/SingleReaExtern.jsx';
import FormReapproExt from './reapproExtern/FormReapproExt.jsx';
import ListReapproExt from './reapproExtern/ListReapproExt.jsx';
import FormDefaultShop from './reapproExtern/FormDefaultShop.jsx';
import { isEmpty } from 'lodash';
import { Button, Box } from '@material-ui/core';
import CardPage from '../../../commonModules/layouts/CardPage.jsx';
import DeleteDialog from '../../../commonModules/interface/DeleteDialog';
import { toast } from 'react-toastify';
import Spin from '../../../commonModules/interface/Spin';
import SingleTransferReapproExt from './transfers/reapproExt/SingleTransferReapproExt';
import ListTransferReapproExt from './transfers/reapproExt/ListTranferReapproExt';

class ReapproExtern extends Component{
    state = { 
        defaultShop: {},
        formDefault: false,
        view: "list",
        breadcrumb: "",
        breadcrumb: "",
        
        deletePopUp: false,
        toDelete:{
            id:""
        },
        mdpAdmin:"",
        errors:{
            mdpAdmin:"",
        },
    }

    componentDidMount = () => {
        // fetch default shop
        this.fetchDefaultShop()
    }
    fetchDefaultShop = async () => {
        try {
            let req = await fetch('/stocks/reappro/ext/default/shop',{
                method:'GET',
                headers: {
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content,
                },
                credentials: 'same-origin',
        
            })
            const res = await req.json()
            console.log('====================================');
            console.log("fetchDefaultShop", {res});
            console.log('====================================');
            
            if(!res.error && !isEmpty(res.id)){
                this.setState({
                    defaultShop: res
                })
            } else {
                this.setState({
                    defaultShop: {},
                    formDefault: true,
                })
            }
        } catch (error) {
            console.log('====================================');
            console.log("fetchDefaultShop catch", error);
            console.log('====================================');
        }
    }

    handleClose = () => {
        this.setState({
            view: "list",
            formDefault: false,
            defaultShop: {},
            breadcrumb: ""
        })
    }
    handleSingleReaExtern = (reappro, shop) => {
        this.setState({
            view:"reappro",
            breadcrumb:`Reappro n°${reappro.id}`,
            singleReappro:{reappro, shop},
        })
    }
    handleSingleShop = (shop) => {
        this.setState({
            breadcrumb: shop.name,
            singleShop:shop,
            view: "shop"
        })
    }
    handleDelete = (reappro) => {
        this.setState({
            toDelete: reappro,
            deletePopUp : true,
        })
    }
    deleteReappro = async () => {

        await this.props.deleteReappro(this.state.toDelete)
        
        if(this.props.STATE.sales.error){
            console.log("[ERROR] delete reappro", this.props.STATE.sales.error); 
            toast.error(  "Un Problème est survenu")
        } else {
            toast.success( "Reappro supprimée avec succès")
            this.setState({
                deletePopUp:false,
                toDelete:{id: ""},
            })
        }  

    }
    
    render(){
        const { formDefault, view } = this.state;
        return(
            <CardPage 
                title="Reappro Externe"
                storehouse
                action={ view === "list" &&
                    <Box>
                        <Button 
                            color="primary" 
                            variant="contained" 
                            onClick={ () => this.setState({ view: "form" })}
                        >
                            Nouveau
                        </Button>
                
                        <Button 
                            color="secondary"
                            // variant="contained"
                            onClick={ () => this.setState({ formDefault: true })}
                        >
                            Modifier Magasin défault
                        </Button>
                    </Box>
                }
            >
                <BreadCrumb breadcrumb={ this.state.breadcrumb } title="Réapprovisionnement externes" back={this.handleClose} />

            {view === "reappro" &&
                <SingleTransferReapproExt 
                    transfer={this.state.singleReappro.reappro} 
                    shop={this.state.singleReappro.shop} 
                    {...this.props} 
                    // getPhoto={this.props.getPhoto} 
                />
            }
            {view === "shop" &&
                <SingleShop shop={this.state.singleShop} {...this.props} />
            }  
            {/* step 1
                    check if exist default shop
                    if not: form default shop
                */}
            {formDefault &&
                <FormDefaultShop 
                    {...this.props}
                    handleClose={this.handleClose}
                />
            }
            {/* Form new reappro ext */}
            {/* Need :
            other account email -> accountID
            match products list
            compare match product list with current product list */}
            {view === "form" &&
                <FormReapproExt 
                    {...this.props}
                    handleClose={this.handleClose}
                />

            }
            {this.state.deletePopUp && this.state.toDelete.id &&
                <DeleteDialog
                    title={"le reapprovisionnement n°"+this.state.toDelete.id}
                    handleSubmit={this.deleteReappro}
                    close={()=>this.setState({deletePopUp: false})}
                    open={true}
                    disabled={this.props.STATE.sales.fetching}
                />
            }
            {this.props.STATE.sales.fetching && <Spin noOverlay/>}
            {view === "list" && 
            <div>
                {/* {!isEmpty(this.props.REAPPRO_EXT) && */}
                    <ListTransferReapproExt 
                        {...this.state}
                        {...this.props}
                        handleSingleShop={this.handleSingleShop}  
                        handleSingleReaExtern={this.handleSingleReaExtern}  
                        handleDelete={this.handleDelete}
                    />
                {/* } */}
            </div>
            }

            </CardPage>

        )
    }
}



export default ReapproExtern